module.exports = (__parcel__import__("dNNHQ")).then(() => parcelRequire('4MKVl'));